export default {
  title: 'Easy Air Screen',
  subtitle: '将您的平板电脑变成无线第二显示器',
  description: '将您的平板电脑转换为macOS的高质量无线显示器。扩展您的工作空间，提高生产力——无需电缆。',
  downloadMobile: '下载移动应用',
  purchasePromise: '一次购买即可。无订阅，无广告。',
  companionPromise: 'Mac 端应用免费，无需注册账户。',
  downloadMacOS: '下载macOS版 (Universal)',
  quickSetup: '快速设置',
  setupSteps: [
    '在您的平板电脑上安装Easy Air Screen',
    '下载并安装macOS的桌面应用',
    '将两台设备连接到同一Wi-Fi网络',
    '启动并连接！'
  ],
  performanceTip: '性能提示',
  performanceDescription: '为了获得最佳体验和最小延迟，请在两台设备上使用5GHz Wi-Fi连接。如果注意到延迟，请尝试在应用设置中降低分辨率。',
  faqTitle: '常见问题',
  faq: [
    {
      q: '它和 Sidecar 有什么不同？',
      a: 'Easy Air Screen 即使两台设备使用不同的 Apple ID 也能连接。Android 平板也可以作为 Mac 的无线副显示器使用。'
    },
    {
      q: 'Android 平板也可以使用吗？',
      a: '可以。Android 平板可以作为 Mac 的无线副显示器使用。将两台设备连接到同一 Wi-Fi 后，可选择扩展或复制屏幕。'
    },
    {
      q: 'iPhone 也能作为副显示器吗？',
      a: '可以。iPhone 可以作为 Mac 的无线副显示器使用。连接后，您可以选择扩展屏幕或复制当前画面。'
    },
    {
      q: '支持扩展屏幕还是镜像？',
      a: '两者都支持。您可以将 Mac 桌面扩展到另一块屏幕，也可以复制当前 Mac 屏幕，显示相同内容。'
    },
    {
      q: '需要互联网吗？屏幕会传到外部吗？',
      a: '不需要互联网连接。设备会在同一 Wi-Fi 内直接连接，屏幕不会经过外部服务器，也不会被保存。'
    },
    {
      q: '这是订阅服务吗？',
      a: '不是。设备端 App 只需一次购买，不是订阅，也没有广告。Mac 端配套 App 免费使用，且无需注册账户。'
    },
    {
      q: 'Windows PC 也能使用吗？',
      a: '不能。Easy Air Screen 仅支持 macOS。目前不支持 Windows PC。'
    },
    {
      q: '屏幕卡顿或延迟时该怎么办？',
      a: '请尽量让两台设备连接到 5GHz Wi-Fi。如果仍感觉延迟，可在 App 设置中降低分辨率。'
    },
  ]
};
